import { Dropdown } from 'legacy/lut/library/dropdown'
import React, { useMemo, useState } from 'react'

import { Button } from 'core-components/library/button'
import { LoaderOverlay } from 'core-components/library/loader'
import {
  Controller,
  isEmpty,
  ValidateInput,
  ValidationStatus,
} from 'core-components/library/validation'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import styles from './RejectRequestDialog.module.scss'

const reasons = [
  'Wrong request',
  'No action',
  'Void the contract',
  'Rejected by Compliance',
  'Business decision',
  'Other',
]

interface IProps {
  onSave: (value: string) => Promise<void>
  closeModal: () => void
}

export const RejectRequestDialog = ({ closeModal, onSave }: IProps) => {
  const [reason, setReason] = useState('')
  const [reasonComment, setReasonComment] = useState('')
  const [wip, setWip] = useState(false)
  const [validationStatus, setValidationStatus] = useState<ValidationStatus>(
    ValidationStatus.Invalid
  )

  const source = useMemo(() => {
    return new Crud({
      fetcher: new Static(reasons.map((el) => ({ key: el, label: el }))),
      keyField: 'key',
    })
  }, [])

  const saveReason = async () => {
    setWip(true)
    onSave && (await onSave(reason !== 'Other' ? reason : reasonComment))
    setWip(false)
  }

  return (
    <div>
      <LoaderOverlay show={wip} />
      <p className={styles.title}>Please describe the reason of reject</p>
      <Controller
        onValidationStatusChange={({ status }) =>
          status !== ValidationStatus.WIP && setValidationStatus(status)
        }
      >
        <Dropdown
          label="Reason"
          caption="label"
          source={source}
          value={reason}
          onChange={setReason}
          margin={'md'}
        />
        {reason === 'Other' && (
          <ValidateInput
            defaultValue={''}
            margin={'md'}
            label="Comment"
            value={reasonComment}
            onChange={setReasonComment}
            checkFn={isEmpty}
            autoFocus={true}
          />
        )}
        <div className={styles.btnWrapper}>
          <Button className={styles.btnWrapper__btn} margin={'md'} onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button
            color="danger"
            margin={'md'}
            disabled={reason === 'Other' && validationStatus !== ValidationStatus.Valid}
            onClick={() => saveReason()}
          >
            Save
          </Button>
        </div>
      </Controller>
    </div>
  )
}
